export const solutionWordsSpanish = [
    'salir',
    'tener',
    'tocar',
    'golpe',
    'hacer',
    'nuevo',
    'deseo',
    'apoyo',
    'unico',
    'valor',
    'poder',
    'crear',
    'segun',
    'miedo',
    'perro',
    'subir',
    'orden',
    'mucho',
    'saber',
    'comer',
    'tomar',
    'largo',
    'pedir',
    'sacar',
    'poner',
    'causa',
    'amigo',
    'bajar',
    'mujer',
    'vacio',
    'karma',
    'armar',
    'parte',
    'mundo',
    'nivel',
    'mejor',
    'grupo',
    'feliz',
    'donde',
    'hecho',
    'jugar',
    'decir',
    'carta',
    'dulce',
    'bella',
    'claro',
    'final',
    'mayor',
    'luego',
    'snack',
    'bueno',
    'regla',
    'lugar',
    'etapa',
    'sabio',
    'antes',
    'forma',
    'dejar',
    'mirar',
    'exito',
    'tenaz',
    'soñar',
    'coger',
    'tarea',
    'calma',
    'ayuda',
    'ahora',
    'viaje',
    'deber',
    'cerca',
    'ideal',
    'norma',
    'falta',
    'dicha',
    'lleno',
    'hueco',
    'tanto',
    'campo',
    'nunca',
    'papel',
    'girar',
    'habil',
    'frase',
    'suave',
    'punto',
    'libro',
    'volar',
    'dueño',
    'señal',
    'union',
    'otoño',
    'lento',
    'salud',
    'dotar',
    'tarde',
    'debil',
    'libre',
    'arbol',
    'facil',
    'culpa',
    'comun',
    'pasar',
    'dolor',
    'breve',
    'animo',
    'friki',
    'yerno',
    'flujo',
    'lindo',
    'capaz',
    'venta',
    'cielo',
    'ojala',
    'haber',
    'traer',
    'pluma',
    'abrir',
    'viejo',
    'matar',
    'banal',
    'local',
    'icono',
    'flaco',
    'oveja',
    'epoca',
    'labor',
    'rumbo',
    'globo',
    'total',
    'grito',
    'spray',
    'ebano',
    'firme',
    'denso',
    'pobre',
    'copia',
    'señor',
    'estar',
    'igual',
    'mania',
    'osado',
    'vivir',
    'gordo',
    'senda',
    'chico',
    'futil',
    'ciego',
    'vasto',
    'clase',
    'temor',
    'parar',
    'pagar',
    'creer',
    'serio',
    'veloz',
    'lejos',
    'mismo',
    'honor',
    'optar',
    'etica',
    'sobre',
    'basar',
    'morir',
    'razon',
    'medio',
    'audaz',
    'jamas',
    'ufano',
    'error',
    'color',
    'motor',
    'curar',
    'joven',
    'ocaso',
    'parco',
    'dieta',
    'suelo',
    'justo',
    'corte',
    'plano',
    'burdo',
    'ganar',
    'echar',
    'grave',
    'grato',
    'broma',
    'gente',
    'pieza',
    'acido',
    'sucio',
    'visto',
    'ajeno',
    'gozar',
    'texto',
    'culto',
    'donar',
    'furor',
    'queja',
    'corto',
    'clave',
    'durar',
    'sueño',
    'usted',
    'brisa',
    'valla',
    'hogar',
    'fondo',
    'obvio',
    'gusto',
    'bello',
    'meter',
    'nacer',
    'cauto',
    'listo',
    'sello',
    'medir',
    'mover',
    'guapa',
    'hasta',
    'arido',
    'fluir',
    'rueda',
    'pausa',
    'lecho',
    'tonto',
    'celos',
    'legal',
    'casta',
    'aroma',
    'stock',
    'pegar',
    'punta',
    'dicho',
    'cinta',
    'pasto',
    'beber',
    'ciclo',
    'regar',
    'padre',
    'turno',
    'noche',
    'playa',
    'danza',
    'calor',
    'juego',
    'andar',
    'logro',
    'lucha',
    'bingo',
    'oasis',
    'robar',
    'niños',
    'tejer',
    'recto',
    'azada',
    'madre',
    'negro',
    'grado',
    'verde',
    'sumar',
    'agrio',
    'resta',
    'lider',
    'voraz',
    'enojo',
    'vicio',
    'pesar',
    'pelea',
    'fruto',
    'epico',
    'cerdo',
    'burla',
    'falso',
    'cifra',
    'actor',
    'fijar',
    'burro',
    'dudar',
    'junto',
    'carro',
    'monte',
    'deuda',
    'huevo',
    'signo',
    'tapar',
    'tenue',
    'sutil',
    'mente',
    'cargo',
    'pisar',
    'rubro',
    'pista',
    'clima',
    'clara',
    'algun',
    'motin',
    'costa',
    'trama',
    'movil',
    'fauna',
    'linda',
    'trato',
    'notar',
    'marco',
    'axial',
    'zorro',
    'pulso',
    'noble',
    'obrar',
    'rigor',
    'obeso',
    'linea',
    'regir',
    'vital',
    'calle',
    'ruido',
    'serie',
    'iluso',
    'favor',
    'topar',
    'autor',
    'guiar',
    'veraz',
    'tirar',
    'ancho',
    'sagaz',
    'shock',
    'dosis',
    'drama',
    'ceder',
    'barco',
    'curso',
    'busca',
    'rogar',
    'guapo',
    'fuera',
    'dañar',
    'elite',
    'prado',
    'marca',
    'cruel',
    'ritmo',
    'avaro',
    'docto',
    'staff',
    'idolo',
    'omiso',
    'chica',
    'curva',
    'jaula',
    'llama',
    'velar',
    'ojota',
    'bahia',
    'avido',
    'ebrio',
    'urdir',
    'baile',
    'nueva',
    'yacer',
    'tenia',
    'stand',
    'gesto',
    'citar',
    'valle',
    'ahito',
    'nicho',
    'silla',
    'ganas',
    'sitio',
    'ceñir',
    'negar',
    'vigor',
    'vuelo',
    'docil',
    'bravo',
    'lista',
    'vista',
    'chapa',
    'cueva',
    'cesar',
    'firma',
    'fuego',
    'usado',
    'pacto',
    'letal',
    'flojo',
    'usual',
    'ameno',
    'lucir',
    'buena',
    'pilar',
    'necio',
    'habla',
    'hacia',
    'huida',
    'tumba',
    'duelo',
    'astro',
    'venir',
    'lapiz',
    'canon',
    'jalar',
    'avion',
    'magia',
    'unido',
    'banco',
    'pompa',
    'aquel',
    'agudo',
    'moral',
    'torpe',
    'furia',
    'hobby',
    'aviso',
    'apice',
    'tesis',
    'arduo',
    'digno',
    'rabia',
    'obito',
    'abuso',
    'norte',
    'rival',
    'ojear',
    'genio',
    'faena',
    'raudo',
    'ozono',
    'trozo',
    'valer',
    'ijada',
    'herir',
    'temer',
    'paseo',
    'tapia',
    'apego',
    'salon',
    'coche',
    'fallo',
    'vejez',
    'hielo',
    'socio',
    'rural',
    'resto',
    'sanar',
    'cerro',
    'carga',
    'techo',
    'parca',
    'horda',
    'mando',
    'ileso',
    'legar',
    'ligar',
    'rasgo',
    'yerro',
    'humor',
    'terco',
    'mojar',
    'tosco',
    'opaco',
    'sabor',
    'lobby',
    'cagar',
    'leche',
    'pleno',
    'heroe',
    'senil',
    'yermo',
    'cabal',
    'pared',
    'feroz',
    'alzar',
    'pavor',
    'poeta',
    'ojera',
    'gasto',
    'otear',
    'ansia',
    'venia',
    'canal',
    'soler',
    'mitad',
    'atrio',
    'bruto',
    'caida',
    'pauta',
    'beodo',
    'etnia',
    'bogar',
    'cutre',
    'metal',
    'lucro',
    'droga',
    'borde',
    'surco',
    'harto',
    'dogma',
    'susto',
    'pulir',
    'nieve',
    'menos',
    'raspa',
    'costo',
    'rezar',
    'falaz',
    'sudar',
    'parra',
    'ganso',
    'novio',
    'tedio',
    'presa',
    'toque',
    'lapso',
    'cajon',
    'salto',
    'koala',
    'fosil',
    'amado',
    'media',
    'santo',
    'relax',
    'lavar',
    'menor',
    'ninfa',
    'molde',
    'doble',
    'simil',
    'chino',
    'catar',
    'falla',
    'jerga',
    'alado',
    'navio',
    'rayar',
    'bruja',
    'ruina',
    'raton',
    'radio',
    'errar',
    'rozar',
    'barro',
    'letra',
    'super',
    'lycra',
    'diosa',
    'regio',
    'quedo',
    'verbo',
    'aunar',
    'tenso',
    'balon',
    'prisa',
    'obice',
    'rumor',
    'plazo',
    'zurdo',
    'Jesus',
    'carne',
    'rango',
    'poema',
    'secar',
    'besar',
    'odiar',
    'angel',
    'picar',
    'idear',
    'jiron',
    'reino',
    'niñez',
    'llave',
    'plato',
    'nuera',
    'tumor',
    'anexo',
    'basto',
    'fatal',
    'caber',
    'hilar',
    'ayuno',
    'atroz',
    'ideas',
    'truco',
    'rocio',
    'banda',
    'ardid',
    'boton',
    'turba',
    'circo',
    'envio',
    'plaza',
    'gruta',
    'vapor',
    'hueso',
    'hurto',
    'mutuo',
    'cisma',
    'junta',
    'enano',
    'semen',
    'bolso',
    'selva',
    'rampa',
    'atras',
    'garbo',
    'oeste',
    'virus',
    'matiz',
    'reves',
    'rodar',
    'catre',
    'extra',
    'ejote',
    'acero',
    'llano',
    'porte',
    'fugaz',
    'mitin',
    'rollo',
    'vagar',
    'botar',
    'salvo',
    'feria',
    'multa',
    'teñir',
    'timon',
    'fatuo',
    'callo',
    'torre',
    'impar',
    'otero',
    'flora',
    'untar',
    'cavar',
    'vedar',
    'ujier',
    'pugna',
    'gesta',
    'batir',
    'zafio',
    'tacto',
    'urgir',
    'nimio',
    'heces',
    'probo',
    'manso',
    'short',
    'telar',
    'mueca',
    'fibra',
    'vetar',
    'ronda',
    'traje',
    'vivaz',
    'casar',
    'peste',
    'coste',
    'aovar',
    'trino',
    'nadar',
    'abajo',
    'treta',
    'verso',
    'bolsa',
    'traba',
    'polvo',
    'coser',
    'bulto',
    'barra',
    'quiza',
    'disco',
    'pasta',
    'tañer',
    'arena',
    'plaga',
    'yelmo',
    'aereo',
    'bulla',
    'pudor',
    'reina',
    'hosco',
    'coito',
    'mimar',
    'novel',
    'votar',
    'monje',
    'atajo',
    'vacuo',
    'fecha',
    'hedor',
    'azote',
    'atado',
    'berma',
    'cuota',
    'espia',
    'curvo',
    'vejar',
    'oxear',
    'ruego',
    'orate',
    'haren',
    'malla',
    'mixto',
    'parir',
    'cirio',
    'choza',
    'kefir',
    'indio',
    'rubio',
    'barca',
    'manar',
    'brazo',
    'patio',
    'sesgo',
    'nariz',
    'mamar',
    'atril',
    'golfo',
    'grano',
    'ajado',
    'yerba',
    'exodo',
    'pasmo',
    'cruce',
    'gueto',
    'tribu',
    'ataud',
    'tutor',
    'cegar',
    'sobra',
    'impio',
    'trazo',
    'cazar',
    'prosa',
    'pillo',
    'valia',
    'crudo',
    'gemir',
    'rugir',
    'morro',
    'panel',
    'himno',
    'asear',
    'ardor',
    'bañar',
    'perla',
    'istmo',
    'cauce',
    'utero',
    'pinta',
    'barba',
    'helar',
    'okupa',
    'buque',
    'tenis',
    'dardo',
    'arder',
    'tabla',
    'brote',
    'censo',
    'lanza',
    'finca',
    'fruta',
    'trago',
    'bando',
    'torta',
    'rodeo',
    'quema',
    'pecho',
    'sopor',
    'araña',
    'tieso',
    'sudor',
    'vario',
    'civil',
    'yogur',
    'funda',
    'latir',
    'reñir',
    'cenit',
    'manta',
    'gnomo',
    'falda',
    'raido',
    'hebra',
    'ocupa',
    'recio',
    'musgo',
    'bruma',
    'minar',
    'oreja',
    'zanja',
    'preso',
    'apodo',
    'tasar',
    'timar',
    'macho',
    'gorra',
    'rapto',
    'coral',
    'asilo',
    'plata',
    'saldo',
    'savia',
    'casto',
    'canto',
    'nylon',
    'prole',
    'colar',
    'robot',
    'calvo',
    'moler',
    'uvula',
    'rehen',
    'temas',
    'hondo',
    'cariz',
    'cesta',
    'persa',
    'nimbo',
    'farsa',
    'falto',
    'bomba',
    'pañal',
    'peaje',
    'tropa',
    'bicho',
    'laico',
    'saeta',
    'grasa',
    'perra',
    'placa',
    'brezo',
    'clavo',
    'lerdo',
    'terso',
    'halar',
    'acoso',
    'abono',
    'aliar',
    'etico',
    'rotar',
    'añejo',
    'buril',
    'ducha',
    'efebo',
    'yerto',
    'jaleo',
    'cuero',
    'chulo',
    'tallo',
    'canoa',
    'monto',
    'porno',
    'yunta',
    'celda',
    'agape',
    'porra',
    'primo',
    'yegua',
    'acaso',
    'casco',
    'farol',
    'frito',
    'galan',
    'guisa',
    'fuero',
    'desde',
    'trapo',
    'labio',
    'mareo',
    'zafar',
    'trono',
    'judio',
    'ganga',
    'usura',
    'calar',
    'soplo',
    'naipe',
    'zaino',
    'penar',
    'cable',
    'aleta',
    'mecha',
    'emulo',
    'domar',
    'fiera',
    'aojar',
    'monja',
    'fardo',
    'junco',
    'viril',
    'axila',
    'cubil',
    'pollo',
    'llaga',
    'talud',
    'solaz',
    'pardo',
    'colmo',
    'limar',
    'oidor',
    'tibia',
    'cuate',
    'sorna',
    'ultra',
    'halla',
    'beato',
    'cursi',
    'quita',
    'sonda',
    'guion',
    'honra',
    'limbo',
    'brasa',
    'segar',
    'mudar',
    'gorro',
    'podar',
    'ñandu',
    'justa',
    'orgia',
    'rubor',
    'plebe',
    'ornar',
    'egida',
    'talla',
    'bazar',
    'tapon',
    'titan',
    'esmog',
    'rizar',
    'labia',
    'cebar',
    'doler',
    'cerco',
    'renta',
    'caido',
    'dueto',
    'nevar',
    'hiato',
    'alero',
    'ixtle',
    'lloro',
    'kepis',
    'gramo',
    'ovalo',
    'talar',
    'apero',
    'vagon',
    'pizca',
    'jabon',
    'vulva',
    'marea',
    'pecar',
    'cabra',
    'blusa',
    'asado',
    'lamer',
    'dorso',
    'glosa',
    'bardo',
    'aforo',
    'aldea',
    'pesca',
    'lente',
    'flota',
    'jadeo',
    'apuro',
    'garra',
    'credo',
    'cobro',
    'cutis',
    'vulgo',
    'tinte',
    'felon',
    'crema',
    'argot',
    'gallo',
    'fisco',
    'arabe',
    'freno',
    'hipar',
    'natal',
    'hucha',
    'varon',
    'ungir',
    'joder',
    'bedel',
    'video',
    'caqui',
    'palma',
    'secta',
    'prior',
    'magro',
    'water',
    'ambos',
    'brujo',
    'anima'
];
